var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Keyboard',{model:{value:(_vm.keyboard),callback:function ($$v) {_vm.keyboard=$$v},expression:"keyboard"}}),_c('v-text-field',{attrs:{"name":"name","label":"label","id":"id"},on:{"click":_vm.show}}),_c('v-btn',{attrs:{"elevation":"2"},on:{"click":function($event){_vm.keyboard.visible = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }